import React, { createContext, useEffect, useState, useRef } from "react";
import axios from "./axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import pusher from "../../pusher";
import logo from "../../logo2.png";
import useServiceWorker from '../../hooks/useServiceWorker';



const STcontext = createContext();

export const STProvider = ({ children }) => {

   const { sendSWNotification, requestPermission } = useServiceWorker();


   const initialized = useRef(false); // ← ajouter
   const taskToConfirmedRef = useRef([]);

   const [previousTaskCount, setPreviousTaskCount] = useState(0);
   const [loadingFilter, setLoadingFilter] = useState(false);
   const [showGlobalNotification, setShowGlobalNotification] = useState(false);
   const [newTasksGlobal, setNewTasksGlobal] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      if (initialized.current) return;
      initialized.current = true;

      getAllGps();
      getAllSim();

      // S'abonner aux notifications PUSHER au niveau GLOBAL
      subscribeToRealtimeUpdates();

      // Charger les tâches initiales
      getTasktoConfirmed();

      requestPermission();

      return () => {
         // Nettoyage quand l'application se ferme
         // pusher.unsubscribe("Installer_realTime");
      };
   }, []);


   // Fonction pour récupérer les tâches mises à jour
   const fetchUpdatedTasks = async () => {
      const oldCount = taskToConfirmedRef.current.length;
      try {
         const response = await axios.get("/api/supportTechnique/tasksToConfirmed");
         const newTasksData = response.data;

         if (newTasksData.length > oldCount && oldCount > 0) {
            const newTasksCount = newTasksData.length - oldCount;
            const latestTasks = newTasksData.slice(0, newTasksCount);
            showGlobalTaskNotification(newTasksCount, latestTasks);
            setNewTasksGlobal(latestTasks);
            setShowGlobalNotification(true);
         }

         updateTaskToConfirmed(newTasksData); // ← mettre à jour APRÈS comparaison

      } catch (error) {
         console.error("❌ Erreur fetchUpdatedTasks:", error);
      }
   };

   // subscribeToRealtimeUpdates — plus besoin de passer oldCount
   const subscribeToRealtimeUpdates = () => {
      const channel = pusher.subscribe("Installer_realTime");

      channel.bind("realTimeData", (data) => {
         console.log("🔄 Mise à jour globale reçue:", data);
         fetchUpdatedTasks(); // ← sans argument
      });
   };

   // Fonction pour afficher une notification globale
   const showGlobalTaskNotification = (count, tasks) => {
      toast(
         <div
            onClick={() => window.location.href = '/support-technique/taches-a-confirmer'}
            style={{ cursor: 'pointer', fontFamily: "'Segoe UI', sans-serif" }}
         >
            {/* Header */}
            <div style={{
               display: 'flex',
               alignItems: 'center',
               gap: '10px',
               marginBottom: '10px',
               paddingBottom: '10px',
               borderBottom: '1px solid rgba(255,255,255,0.2)'
            }}>
               <div style={{
                  backgroundColor: '#ff4444',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  flexShrink: 0,
                  boxShadow: '0 2px 8px rgba(255,68,68,0.4)'
               }}>
                  🔔
               </div>
               <div>
                  <div style={{
                     fontWeight: '700',
                     fontSize: '0.95em',
                     color: '#fff',
                     letterSpacing: '0.3px'
                  }}>
                     {count} nouvelle{count > 1 ? 's' : ''} tâche{count > 1 ? 's' : ''} à confirmer
                  </div>
                  <div style={{
                     fontSize: '0.75em',
                     color: 'rgba(255,255,255,0.7)',
                     marginTop: '2px'
                  }}>
                     Cliquez pour voir les détails
                  </div>
               </div>
            </div>

            {/* Liste des tâches */}
            {tasks && tasks.length > 0 && (
               <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {tasks.slice(0, 3).map((task, index) => (
                     <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        borderRadius: '6px',
                        padding: '6px 10px',
                        fontSize: '0.82em',
                     }}>
                        <div style={{
                           width: '6px',
                           height: '6px',
                           borderRadius: '50%',
                           backgroundColor: '#4ade80',
                           flexShrink: 0
                        }} />
                        <span style={{ color: '#fff', fontWeight: '600' }}>
                           {task.nomComplet}
                        </span>
                        <span style={{ color: 'rgba(255,255,255,0.6)' }}>—</span>
                        <span style={{ color: 'rgba(255,255,255,0.8)' }}>
                           {task.catache}
                        </span>
                     </div>
                  ))}
                  {tasks.length > 3 && (
                     <div style={{
                        fontSize: '0.78em',
                        color: 'rgba(255,255,255,0.6)',
                        textAlign: 'center',
                        paddingTop: '4px'
                     }}>
                        + {tasks.length - 3} autre{tasks.length - 3 > 1 ? 's' : ''} tâche{tasks.length - 3 > 1 ? 's' : ''}
                     </div>
                  )}
               </div>
            )}
         </div>,
         {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 10000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
               background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
               border: '1px solid rgba(255,255,255,0.1)',
               borderRadius: '12px',
               boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
               padding: '16px',
               minWidth: '320px',
            },
            progressStyle: {
               background: 'linear-gradient(90deg, #ff4444, #ff8c00)',
            },
         }
      );

      sendSWNotification(
         `🔔 ${count} nouvelle${count > 1 ? 's' : ''} tâche${count > 1 ? 's' : ''} à confirmer`,
         tasks.slice(0, 3).map(t => `• ${t.nomComplet} - ${t.catache}`).join('\n'),
         tasks
      );

      // 3. Titre de la page
      updatePageTitle(count);
   };


   // Jouer un son
   const playNotificationSound = () => {
      try {
         const audio = new Audio('/notification-sound.mp3');
         audio.play().catch(e => console.log('Son bloqué par le navigateur'));
      } catch (error) {
         console.log('Erreur lecture son:', error);
      }
   };

   // Mettre à jour le titre de la page
   const updatePageTitle = (count) => {
      const originalTitle = document.title;
      document.title = `(${count}) Nouvelles tâches - ${originalTitle}`;

      // Restaurer le titre après 10 secondes
      setTimeout(() => {
         document.title = originalTitle;
      }, 30000);
   };


   // Fonction pour réinitialiser le badge de notification
   const resetNotificationBadge = () => {
      setShowGlobalNotification(false);
      setNewTasksGlobal([]);
   };


   const URL_Notification = "/api/fcm/send";
   const [responseMessage, setResponseMessage] = useState();
   const [checkboxaccessoire, setcheckboxAssessoire] = useState(false);
   const [commercial, setCommercial] = useState([]);
   const [tasksST, setTasksST] = useState(null);
   const [statisticsTasksDashboard, setStatisticsDashboard] = useState([]);
   const [errorsMessages, setErrorsMessages] = useState();
   const [statisticsTasks, setStatistics] = useState([]);
   const [gerantAppareil, setGerantAppareil] = useState({
      numberGPS: null,
      numberSIM: null,
      ACCESSORY: null,
      gpsUserAssociate: [],
      mostmodel: [],
   });
   const [appareil, setAppareil] = useState({
      numberGPS: [],
      numberSIM: [],
      ACCESSORY: [],
      mostmodel: [],
   });

   const [allGps, setAllGps] = useState([]);
   const [allSim, setAllSim] = useState([]);

   const [appareilInstalle, setAppareilInstalle] = useState({
      numberGPS: null,
      SIM: [],
      ACCESSORY: [],
      mostmodel: [],
      final: [],
   });
   const [NewTask, setNewTask] = useState({
      Clients: [],
      TypesTasks: [],
      TypesDevice: [],
      Articles: [],
      SIM: [],
      Accessories: [],
      Users: [],
      Cities: [],
   });
   const [AffectedArticle, setAffectedArticle] = useState({
      technicien: "",
   });

   const [CheckBoxAffectedArticle, setCheckBoxAffectedArticle] = useState([]);
   const [technicien, setTechnicien] = useState([]);

   const [getStatisticsTasks, setGetStatisticsTasks] = useState({
      categoreyTask: 1,
      etaTask: 2,
      date: "weeks",
   });
   //error messege Function
   const showErrorMessage = (message) => {
      toast.error(message, {
         position: toast.POSITION.TOP_RIGHT,
      });
   };

   // Success Message toast
   const showSuccessMessage = (message) => {
      toast.success(message, {
         position: toast.POSITION.TOP_RIGHT,
      });
   };

   // get all tasks (validate[1,2] and where data affectation)
   const getTask = async (dateDebut, dateFin, profil) => {
      try {
         const response = await axios.get(
            `/api/supportTechnique/technicien/${dateDebut}/${dateFin}/${profil}`
         );
         setStatisticsDashboard(response.data);
      } catch (error) {
         showErrorMessage("data is required");
      }
   };
   const handleChangeDateStatistics = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setGetStatisticsTasks({
         ...getStatisticsTasks,
         [name]: value,
      });
   };

   const getStatisticsTasksTechnicien = () => {
      axios
         .get(
            `/api/supportTechnique/statisticsTasks/${getStatisticsTasks.etaTask}/${getStatisticsTasks.categoreyTask}/${getStatisticsTasks.date}`
         )
         .then((response) => {
            setStatistics(response.data);
         });
   };

   const [isFilterTask, setIsFilterTask] = useState(false);

   //filter Tasks preDate by date fin realisation
   const filteringPerDate = async (startDate, endDate, profil) => {
      const dateFromTo = {
         date_presionnel_début: startDate,
         date_presionnel_fin: endDate,
      };

      sessionStorage.setItem("dateFilter", JSON.stringify(dateFromTo));
      setIsFilterTask(true);

      try {
         const date = [startDate, endDate];

         const [statsResponse] = await Promise.all([
            axios.get(
               `/api/supportTechnique/statisticsTasks/${getStatisticsTasks.etaTask}/${getStatisticsTasks.categoreyTask}/${date}`
            ),
            getTask(startDate, endDate, profil),
            getAppareilInstalle(startDate, endDate),
         ]);

         setStatistics(statsResponse.data);

      } catch (error) {
         console.error("Erreur filtrage :", error);
      }
   };

   const handleAffectedArticleOption = (CheckBoxAffectedArticle) => {
      setAffectedArticle({
         ...AffectedArticle,
         Articles: CheckBoxAffectedArticle,
      });
   };

   const handleAffectedTechnicianOption = (e) => {
      const { name, value } = e.target;
      setAffectedArticle({
         ...AffectedArticle,
         [name]: value,
      });
   };

   useEffect(() => {
      setAffectedArticle((prevAffectedArticle) => ({
         ...prevAffectedArticle,
         Articles: CheckBoxAffectedArticle,
      }));
   }, [CheckBoxAffectedArticle]);

   const technicianAll = async () => {
      await axios.get("/api/supportTechnique/techniciesAll").then((res) => {
         setTechnicien(res.data);
      });
   };

   const handleAffectedCheckBox = (e, article) => {
      const { name, checked, id } = e.target;
      if (article.serial_number === id) {
         if (checked === true) {
            setAffectedArticle({
               ...AffectedArticle,
               [name]: checked,
               IMEI: article.serial_number,
            });
         } else {
            setAffectedArticle({ ...AffectedArticle, [name]: false, IMEI: "" });
         }
      }
   };

   const SubmittedToTechnician = async () => {
      try {
         setIsLoading(true);
         await axios.post(
            "/api/supportTechnique/AffectedArticle",
            AffectedArticle
         );
         setErrorsMessages();
         await getAppareil();
         await getGerantAppareil();
         setIsLoading(false);
         setAffectedArticle({ ...AffectedArticle, Articles: null });
      } catch (error) {
         setIsLoading(false);
         setErrorsMessages(error.response.data.errors);
      }
   };

   const getAppareil = async () => {
      const response = await axios.get("/api/supportTechnique/AllAppareils");
      setAppareil(response.data);
   };
   const getAllGps = async () => {
      const response = await axios.get("/api/supportTechnique/AllGps");
      setAllGps(response.data);
   };
   const getAllSim = async () => {
      const response = await axios.get("/api/supportTechnique/AllSim");
      setAllSim(response.data);
   };

   const getGerantAppareil = async () => {
      const response = await axios.get("/api/gerant/allAppareils");
      setGerantAppareil(response.data);
   };

   //show all appareil per user
   const [apparielsPerUser, setAppareilPerUser] = useState([]);
   const [showApparielPreUser, setShowAppareilPerUser] = useState(false);
   const getAppareilsPerUser = async (userId, typeId) => {
      setShowAppareilPerUser(true);
      const response = await axios.get(
         `/api/gerant/getAppareilsPerUser/${userId}/${typeId}`
      );
      setAppareilPerUser(response.data);
   };

   const getAppareilInstalle = async (startDate, endDate) => {
      const response = await axios.get(
         `/api/supportTechnique/AllAppareilInstalle/${startDate}/${endDate}`
      );
      setAppareilInstalle(response.data);
   };

   //start all tasks function's
   //get all task Of commercial
   const getCommercial = async () => {
      const response = await axios.get("/api/supportTechnique/commercial");
      setCommercial(response.data);
   };
   // end get all task Of   commercial

   //get all task Of ST
   const getStTaches = async () => {
      const res = await axios.get("/api/supportTechnique/supporttechnicienTask");
      setTasksST(res.data.taskSupportTechnique);
   };
   //end get all task Of ST

   const [vehiclesPreClient, setVehiclesPreClient] = useState(null);

   const getAllVehiclesPreClient = async (client_id) => {
      const response = await axios.get(
         `/api/supportTechnique/all-vehicles-pre-client/${client_id}`
      );
      setVehiclesPreClient(response.data);
   };

   const [endTaskST, setEndTaskST] = useState({});
   const handleEndTaskST = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setEndTaskST({ ...endTaskST, [name]: value });
   };

   const completTaskSubmit = async (taskId) => {
      try {
         await axios.post(`/api/supportTechnique/complet-task/${taskId}`);
         showSuccessMessage("Tâche terminée avec succès");
         getStTaches();
      } catch (err) {
         showErrorMessage("impossible de terminer cette tâche");
         console.log(err);
      }
   };

   const [delayTaskST, setDelayTaskST] = useState({});
   const handleDelayTaskSTChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setDelayTaskST({ ...delayTaskST, [name]: value });
   };

   const delayTaskSubmit = async (taskId) => {
      try {
         await axios.post(`/api/supportTechnique/delay-task/${taskId}`);
         showSuccessMessage("Tâche reportée avec succès");
         getStTaches();
      } catch (error) {
         showErrorMessage("impossible de reporter cette tâche");
         console.log(error);
      }
   };

   const [cancelTaskST, setCancelTaskST] = useState({});

   const handleCancelTaskSTChange = (e) => {
      const { name, value } = e.target;
      setCancelTaskST({ ...cancelTaskST, [name]: value });
   };

   const cancelTaskSubmit = async (taskId) => {
      try {
         await axios.post(`/api/supportTechnique/cancel-task/${taskId}`);
         showSuccessMessage("Tâche annulée avec succès");
         getStTaches();
      } catch (error) {
         showErrorMessage("impossible de annuler cette tâche");
         console.log(error);
      }
   };

   // filter tasks support Technique

   const filterTasksSupport = async (filterTaks) => {
      try {
         if (filterTaks.user !== null) {
            const response = await axios.post(
               "/api/supportTechnique/filterTasksSupportTechnique",
               filterTaks
            );
            showSuccessMessage("Filtrage effectuer avec success");
            setTasksST(response.data);
         }
      } catch (err) {
         showErrorMessage("impossible de filtrer ces tâches");
         console.log(err);
      }
   };

   //get all tasks to confirmed for ST
   const [taskToConfirmed, setTaskToConfirmed] = useState([]);
   const updateTaskToConfirmed = (data) => {
      taskToConfirmedRef.current = data;
      setTaskToConfirmed(data);
   };
   const getTasktoConfirmed = async () => {
      // await axios.get("/api/supportTechnique/tasksToConfirmed").then((res) => {
      //    setTaskToConfirmed(res.data);
      // });
      try {
         const response = await axios.get("/api/supportTechnique/tasksToConfirmed");
         updateTaskToConfirmed(response.data);
         setPreviousTaskCount(response.data.length);
         return response.data;
      } catch (error) {
         console.error("Erreur getTasktoConfirmed:", error);
         return [];
      }
   };

   //end get all tasks to confirmed for ST

   //update task to confirmed from ST

   const confirmTask = async (e, UpdateTaskToConfirmed, idTask) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         await axios.post(
            `/api/supportTechnique/confirmedTask/${idTask}`,
            UpdateTaskToConfirmed
         );
         showSuccessMessage("La tâche a été validée");
         await getTasktoConfirmed();

         setErrorsMessages();
      } catch (error) {
         setErrorsMessages(error.response.data.errors);
      }
      finally {
         setIsLoading(false);
      }
   };
   const deleteTaskToConfirmed = async (e, id) => {
      setIsLoading(true);
      try {
         await axios.put(`/api/supportTechnique/deleteTaskToConfirmed/${id}`);
         showSuccessMessage("La tâche a été supprimée");
         getTasktoConfirmed();
         setErrorsMessages();
      } catch (e) {
         showErrorMessage("vous ne pouvez pas supprimer cette tâche");
      }
      finally {
         setIsLoading(false);
      }
   };

   // end update task to confirmed from ST

   const validateTasks = async (e, idTask) => {
      const is_validate = e.target.value;
      await axios.put(
         `/api/supportTechnique/validatedTask/${idTask}/${is_validate}`
      );
      filteredData != null && filteredData.length > 0
         ? handleSearchTechnicianTaskPerDateClicked(1)
         : supportTechiqueTechnicianTask();
   };
   //end all tasks function's

   const [filterData, setFilteredData] = useState(null);

   const [inputDate, setInputDate] = useState({ startDate: "", endDate: "" });

   const handleDateChange = async (e) => {
      const { name, value } = e.target;
      setInputDate({ ...inputDate, [name]: value });
   };

   const handleDateClick = async (e) => {
      const res = await axios.get(
         `/api/supportTechnique/searchDateClient/${inputDate.startDate}/${inputDate.endDate}`
      );
      setFilteredData(res.data);
   };

   const getTaskInfo = async () => {
      const response = await axios.get("/api/supportTechnique/newTask");
      setNewTask(response.data);
   };

   //Handle Add New Task To Technicien

   const [AddNewTask, setAddNewTask] = useState({
      telephone: "",
      emailClient: "",
      Quantite: 1,
   });

   const handleAddTaskToTechnicien = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setAddNewTask({ ...AddNewTask, [name]: value });
   };
   //add new task to technicien
   const [task, setSTTEchnicianTask] = useState([]);
   const [show, setShow] = useState(false);

   const supportTechiqueTechnicianTask = async () => {
      const res = await axios.get("/api/supportTechnique/technicienTask");
      setSTTEchnicianTask(res.data.taskTechniciens);
   };

   const addTaskToTechnicien = async (e) => {
      e.preventDefault();
      try {
         setIsLoading(true);
         const response = await axios.post("/api/supportTechnique/newTask/store", AddNewTask);
         if (response.status == 200) {
            showSuccessMessage("tâche ajouter  avec succès");
            setShow(false);
            setIsLoading(false);
            await supportTechiqueTechnicianTask();
            getStTaches();
            setAddNewTask({
               Quantite: 1,
            });
            setErrorsMessages();
            axios.post(URL_Notification, {
               title: "Nouvelle tâche assignée",
               // body: `${AddNewTask.typeTache} pour ${AddNewTask.nomComplet} à ${filterClientInfo.city.where((city) => city.id == AddNewTask.clientCity).cityName} `,
               body: `${AddNewTask.typeTache} pour ${AddNewTask.nomComplet} `,
               data: {
                  detais: "Vous avez une nouvelle tâche à accomplir. Veuillez vérifier votre notification pour plus de détails.",
               },
               user_name: AddNewTask.affecte,
            });
         }
      } catch (error) {
         setIsLoading(false);
         setErrorsMessages(error.response.data.errors);
      }
   };

   // delete image from task 

   const [selectedImages, setSelectedImages] = useState([]);

   const handleCheckboxChange = (event) => {
      const id = event.value;
      let _selectedImages = [...selectedImages];
      if (event.checked) {
         _selectedImages.push(id);
      } else {
         _selectedImages = _selectedImages.filter((i) => i !== id);
      }
      setSelectedImages(_selectedImages);
   }
   const deleteImageFn = async () => {
      try {
         await axios.delete(`/api/supportTechnique/deleteImages`, { data: selectedImages });
         getStTaches();
         setSelectedImages([]);
      } catch (error) {
         showErrorMessage("impossible de supprimer ces images");
         return Promise.reject(error);
      }
   }
   const addTaskToST = async (e) => {
      e.preventDefault();
      try {
         setIsLoading(true);
         const response = await axios.post("/api/supportTechnique/newTask/storeST", AddNewTask);
         if (response.status == 200) {
            setShow(false);
            showSuccessMessage("tâche ajouter  avec succès");
            await supportTechiqueTechnicianTask();
            setIsLoading(false);
            getStTaches();
            setAddNewTask({
               Quantite: 1,
            });
            setErrorsMessages();
         }
      } catch (error) {
         setIsLoading(false);
         setErrorsMessages(error.response.data.errors);
      }
   };

   const handleCheckBoxAccChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setcheckboxAssessoire(!checkboxaccessoire);
   };

   // handelCombinedChange

   //get all task commercial
   const [taskCommercial, setTaskCommercial] = useState([]);

   const getClient = async () => {
      const res = await axios.get("/api/supportTechnique/commercial");
      setTaskCommercial(res.data);
   };

   //end task commercial

   const [addCombination, setAddCombination] = useState({
      GPSID: "",
   });

   const handelCombinedChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setAddCombination({ ...addCombination, [name]: value });
   };

   const SubmitSimCombinaison = async (e, id) => {
      e.preventDefault();
      const res = await axios.post("/api/supportTechnique/assignmentSimToGps", {
         ...addCombination,
         GPSID: id,
      });
      getAppareil();
   };

   const [filterDataDashboardByDate, setFilterDataDashboardBydate] = useState({
      date_presionnel_début: "",
      date_presionnel_fin: "",
   });

   const handleFilteredTaskByDate = (e) => {
      e.preventDefault();
      const { value, name } = e.target;
      setFilterDataDashboardBydate({
         ...filterDataDashboardByDate,
         [name]: value,
      });
   };

   const SubmittedFilteredDashboardDate = async () => {
      const res = axios.get(
         `/api/supportTechnique/filteredDashboardData/`,
         filterDataDashboardByDate
      );
   };

   const [UpdateTaskToConfirmed, setUpdateTaskToConfirmed] = useState({
      nomClient: "",
   });

   const handleUpdateTaskToConfirmed = (e) => {
      const name = e.taget.name;
      const value = e.taget.value;
      setUpdateTaskToConfirmed({ ...UpdateTaskToConfirmed, [name]: value });
   };

   const [inputTechnicianSearch, setInputTechnicianSearch] = useState();

   const [filteredData, setDataFiltering] = useState(null);

   const handleTEchnicianSearchClick = async (e) => {
      const res = await axios.get(
         `/api/supportTechnique/searchTechnician/${inputTechnicianSearch}`
      );
      setDataFiltering(res.data);
   };

   const [searchnInputTEchnicianPerDate, setSearchInputTechnicianPerDate] =
      useState({
         startDate: "",
         endDate: "",
         user: "",
      });

   const handleSearchTechnicianTaskPerDate = (e) => {
      e.preventDefault();
      const { value, name } = e.target;
      setSearchInputTechnicianPerDate({
         ...searchnInputTEchnicianPerDate,
         [name]: value,
      });
   };

   const handleSearchTechnicianTaskPerDateClicked = async (profil_id) => {
      try {
         const res = await axios.get(
            `/api/supportTechnique/searchTechnicianByDate/${profil_id}`,
            {
               params: {
                  startDate: searchnInputTEchnicianPerDate.startDate,
                  endDate: searchnInputTEchnicianPerDate.endDate,
               },
            }
         );
         setDataFiltering(res.data);
      } catch (error) {
         showErrorMessage(error.response.data.errors.startDate[0]);
      }
   };

   const handleSearchSTTaskPerDateClicked = async () => {
      setLoadingFilter(true);
      try {
         const res = await axios.get("/api/supportTechnique/searchStTaskByDate", {
            params: {
               startDate: searchnInputTEchnicianPerDate.startDate,
               endDate: searchnInputTEchnicianPerDate.endDate,
               user: searchnInputTEchnicianPerDate.user,
            },
         });
         showSuccessMessage("tâches filtrées avec succès");
         setTasksST(res.data.taskSupportTechnique);
      } catch (error) {
         showErrorMessage(error.response.data.errors.startDate[0]);
      }
      finally {
         setLoadingFilter(false);
      }
   };

   const clearSearchTasksSTPerDate = () => {
      setSearchInputTechnicianPerDate({ startDate: "", endDate: "", user: "" });
      getStTaches();
   };

   const [inputStSearch, setInputStSearch] = useState();

   const handleSTChange = (e) => {
      e.preventDefault();
      const { value } = e.target;
      if (value != "") {
         setInputStSearch(value);
      }
      if (value == "") {
         supportTechiqueTechnicianTask();
         setDataFiltering(null);
      }
   };

   const handleStSearchClick = async () => {
      const res = await axios.get(
         `/api/supportTechnique/searchStTask/${inputStSearch}`
      );
      setDataFiltering(res.data);
   };

   const [InputStTaskperDate, setSearchStTaskperDate] = useState({
      startDate: "",
      endDate: "",
   });

   const handlefilteredStTaskPerDate = (e) => {
      e.preventDefault();
      const { name, value } = e.target;
      setSearchStTaskperDate({ ...InputStTaskperDate, [name]: value });
   };

   const handleFilterStTaskClick = async () => {
      const res = await axios.get(
         `/api/supportTechnique/searchStByDate/${InputStTaskperDate.startDate}/${InputStTaskperDate.endDate}`
      );
      setDataFiltering(res.data);
   };

   const handleChangeTaskST = async (taksId) => {
      try {
         await axios.post(`/api/supportTechnique/task/${taksId}/inProgress`);
         showSuccessMessage("tâche en cours de traitement");
      } catch (error) {
         showErrorMessage("impossible de modifier cette tâche");
      }
   };
   const makeTaskOnHold = async (taksId) => {
      try {
         await axios.post(`/api/supportTechnique/task/${taksId}/onHold`);
         showSuccessMessage("tâche en attente de traitement");
      } catch (error) {
         showErrorMessage("impossible de modifier cette tâche");
      }
   };

   const deleteTaskTechnicien = async (id) => {
      try {
         await axios.delete(`api/supportTechnique/deleteTask/${id}`);
         filteredData != null && filteredData.length > 0
            ? handleSearchTechnicianTaskPerDateClicked(1)
            : supportTechiqueTechnicianTask();
         showSuccessMessage("tâche supprimer  avec succès");
      } catch (error) {
         showErrorMessage("impossible de supprimer cette tâche");
      }
   };

   const [modeles, setModeles] = useState([]);

   const handleGetAllModeles = async () => {
      const response = await axios.get("/api/supportTechnique/all-modeles");
      setModeles(response.data);
   };
   const [apprareilReturned, setAppareilReturned] = useState([]);

   const getReturnedDevices = () => {
      axios.get("/api/supportTechnique/ReturnedDevice").then((res) => {
         setAppareilReturned(res.data);
      });
   };

   const confirmedReturnDevice = (deviceToReturned, deviceId) => {
      try {
         axios.post(
            `/api/supportTechnique/return-device-to-ST/${deviceId}`,
            deviceToReturned
         );
         showSuccessMessage("l'appareil est revenu avec succès");
         getAppareil();
      } catch (e) {
         setErrorsMessages(e);
      }
   };

   // change endroit appareil from appareils returned to appareils(endamage, bon occasion, new, client)

   const [changeEndroitAppareils, setchangeEndroitAppareils] = useState({});

   const handleChangeEndroitAppareils = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setchangeEndroitAppareils({ ...changeEndroitAppareils, [name]: value });
   };
   const confirmeAcceptanceOfTheDevice = async (e, id) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         const response = await axios.post(
            `api/supportTechnique/confirmeAcceptanceOfTheDevice/${id}`,
            changeEndroitAppareils
         );
         setResponseMessage(response.status);
         getReturnedDevices();
         setchangeEndroitAppareils({});
         setErrorsMessages(null);
      } catch (e) {
         setErrorsMessages(e.response.data.errors);
      }
      finally {
         setIsLoading(false);
      }
   };

   const handleChangeEditAppareil = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      const selectedOption = e.target.options[e.target.selectedIndex]; // Get the selected option
      const data_special = selectedOption.getAttribute("data-special");
      setAffectedArticle({
         ...AffectedArticle,
         [name]: value,
         special: data_special,
      });
   };
   // edit endroit technicien appareil from st
   const editAppareilsPreUser = async (e, userId, typeId) => {
      setIsLoading(true);
      try {
         const response = await axios.put(
            "/api/supportTechnique/editEndroitAppareil",
            AffectedArticle
         );
         setResponseMessage(response.status);
         await getAppareilsPerUser(userId, typeId);
         setIsLoading(false);
      }
      catch (e) {
         setIsLoading(false);
         setErrorsMessages(e.response.data.errors);
      }

   };

   // import sim from ST
   const [importSim, setImportSim] = useState({});
   const [simNotImporter, setSimNotImporter] = useState([]);
   const handleImportSim = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setImportSim({ ...importSim, [name]: value });
   };

   const readExcelFile = async (file) => {
      const readerFile = new FileReader();
      readerFile.onload = (e) => {
         const bufferArray = e.target.result;
         const wb = XLSX.read(bufferArray, { type: "buffer" });
         const wsname = wb.SheetNames[0];
         const ws = wb.Sheets[wsname];
         setImportSim({
            ...importSim,
            simNumber: XLSX.utils
               .sheet_to_json(ws, {
                  header: 1,
                  raw: false,
               })
               .flat(),
         });
      };
      readerFile.readAsArrayBuffer(file);
   };
   const [showImportSim, setShowImportSim] = useState(false);

   const importSimSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         const response = await axios.post(
            "api/supportTechnique/import-sim", {
            ...importSim,
         }
         );
         response.data.sim_not_found.length === 0
            ? setShowImportSim(false)
            : setShowImportSim(true);
         getAppareil();
         setSimNotImporter(response.data.sim_not_found);
      } catch (err) {
         setErrorsMessages(err.response.data.errors);
      }
      finally {
         setIsLoading(false);
      }
   };
   // end import sim function

   // add new sim function

   const [addNewSim, setAddNewSim] = useState({});
   const handleChangeAddNewSim = (e) => {
      const { name, value } = e.target;
      setAddNewSim({ ...addNewSim, [name]: value });
   };
   // target the value of the input
   const inputArr = [
      {
         type: "text",
         id: 1,
         value: "",
      },
   ];
   const [arr, setArr] = useState(inputArr);
   const addInput = () => {
      setArr((s) => {
         return [
            ...s,
            {
               type: "text",
               value: "",
               type_id: "",
            },
         ];
      });
   };

   const [quantityOfAccessories, setQuantityOfAccessories] = useState({
      typeOfRelais: null,
      quantity: 0
   });
   const handleChangeAddAccessoires = (e) => {
      setQuantityOfAccessories({ ...quantityOfAccessories, [e.target.name]: e.target.value });
   }

   const handleAddNewAccessoiresSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         await axios.post("/api/supportTechnique/add-new-accessoires", quantityOfAccessories);
         await getAppareil();
      } catch (error) {
         setErrorsMessages(error.response.data.errors);
      }
      finally {
         setIsLoading(false);
      }
   }
   const handleChangeSimNumber = (e) => {
      e.preventDefault();
      const index = e.target.id;
      setArr((s) => {
         const newArr = s.slice();
         newArr[index].value = e.target.value;
         return newArr;
      });
   };

   useEffect(() => {
      let simNumbers = [];
      arr &&
         arr.map((inputValue) =>
            inputValue.value != "" ? simNumbers.push(inputValue.value) : null
         );
      setAddNewSim({
         ...addNewSim,
         Serie: [...(simNumbers ? simNumbers : "")],
      });
   }, [arr]);
   const handleAddNewSimSubmit = async (e, checked, setChecked) => {
      e.preventDefault();
      setIsLoading(true);
      try {
         await axios.post("/api/supportTechnique/add-new-sim", {
            ...addNewSim
         });
         await getAppareil();
         setAddNewSim({});
         setChecked(false);
         showSuccessMessage("sim ajouter avec succès");
      } catch (error) {
         setErrorsMessages(error.response.data.errors);
      }
      finally {
         setIsLoading(false);
      }
   };

   // end add new sim function
   const handleConfirmAction = async (id) => {
      try {
         await axios.delete(`api/supportTechnique/deleteArticles/${id}`);
         getAppareil();
      } catch (error) {
         console.log(error);
      }
   };
   const [globalSearch, setGlobalSearch] = useState({
      search: "",
      appareilId: "",
   });
   const [globalSearchRes, setGlobalSearchRes] = useState(null);

   const handleGlobalSearch = async (e, appareilId) => {
      setGlobalSearch({
         ...globalSearch,
         search: e.target.value,
         appareilId: appareilId,
      });
      getGlobalSearch();
   };
   const controllerRef = useRef(null);
   const getGlobalSearch = async () => {
      try {
         if (globalSearch.search != "") {
            controllerRef.current?.abort();
            controllerRef.current = new AbortController();
            const response = await axios.get(
               `api/supportTechnique/globalSearch`, {
               signal: controllerRef.current.signal,
               params: {
                  search: globalSearch.search,
                  appareilId: globalSearch.appareilId,
               },
            }
            );
            setGlobalSearchRes(response.data);
         } else {
            setGlobalSearchRes(null);
         }
      } catch (error) {
         if (error.name !== "CanceledError") {
            console.error(error);
         }
      }
   };


   //log devices for manager
   const [logDevices, setLogDevices] = useState([]);
   const getLogOfDevice = async (device) => {
      try {
         const response = await axios.get(
            `/api/gerant/allAppareils/logDevice/${device}`
         );
         setLogDevices(response.data);
      } catch (e) {
         console.log(e);
      }
   };

   return (
      <STcontext.Provider
         value={{
            isLoading,
            loadingFilter,
            showSuccessMessage,
            showErrorMessage,
            setIsLoading,
            handleUpdateTaskToConfirmed,
            UpdateTaskToConfirmed,
            getTask,
            tasksST,
            handleEndTaskST,
            completTaskSubmit,
            handleDelayTaskSTChange,
            delayTaskST,
            setDelayTaskST,
            delayTaskSubmit,
            handleCancelTaskSTChange,
            cancelTaskSubmit,
            filterTasksSupport,
            getTasktoConfirmed,
            confirmTask,
            validateTasks,
            deleteTaskToConfirmed,
            taskToConfirmed,
            getAppareil,
            getAllGps,
            getAllSim,
            allGps,
            setAllGps,
            allSim,
            setAllSim,
            appareil,
            getCommercial,
            commercial,
            filterData,
            handleDateChange,
            inputDate,
            handleDateClick,
            getTaskInfo,
            statisticsTasksDashboard,
            NewTask,
            getAppareilInstalle,
            appareilInstalle,
            getGerantAppareil,
            gerantAppareil,
            AffectedArticle,
            handleAffectedCheckBox,
            handleAffectedTechnicianOption,
            SubmittedToTechnician,
            technicianAll,
            technicien,
            handleAddTaskToTechnicien,
            AddNewTask,
            handleCheckBoxAccChange,
            checkboxaccessoire,
            handleAffectedArticleOption,
            CheckBoxAffectedArticle,
            setAddNewTask,
            addTaskToTechnicien,
            addTaskToST,
            supportTechiqueTechnicianTask,
            task,
            setAffectedArticle,
            setCheckBoxAffectedArticle,
            handelCombinedChange,
            addCombination,
            setAddCombination,
            SubmitSimCombinaison,
            handleFilteredTaskByDate,
            SubmittedFilteredDashboardDate,
            handleTEchnicianSearchClick,
            filteredData,
            setDataFiltering,
            handleSearchTechnicianTaskPerDate,
            handleSearchTechnicianTaskPerDateClicked,
            handleSearchSTTaskPerDateClicked,
            clearSearchTasksSTPerDate,
            searchnInputTEchnicianPerDate,
            setSearchInputTechnicianPerDate,
            getClient,
            taskCommercial,
            handleSTChange,
            inputStSearch,
            handleStSearchClick,
            handleFilterStTaskClick,
            handlefilteredStTaskPerDate,
            InputStTaskperDate,
            getStTaches,
            getAllVehiclesPreClient,
            vehiclesPreClient,
            show,
            setShow,
            isFilterTask,
            setIsFilterTask,
            setTasksST,
            getStatisticsTasks,
            statisticsTasks,
            getStatisticsTasksTechnicien,
            handleChangeDateStatistics,
            filteringPerDate,
            setStatistics,
            getAppareilsPerUser,
            apparielsPerUser,
            setAppareilPerUser,
            showApparielPreUser,
            setShowAppareilPerUser,
            handleChangeTaskST,
            makeTaskOnHold,
            apprareilReturned,
            getReturnedDevices,
            confirmedReturnDevice,
            confirmeAcceptanceOfTheDevice,
            deleteTaskTechnicien,
            editAppareilsPreUser,
            responseMessage,
            setResponseMessage,
            handleChangeEditAppareil,
            handleChangeEndroitAppareils,
            setchangeEndroitAppareils,
            changeEndroitAppareils,
            handleImportSim,
            readExcelFile,
            importSimSubmit,
            showImportSim,
            setShowImportSim,
            simNotImporter,
            setSimNotImporter,
            errorsMessages,
            setErrorsMessages,
            handleConfirmAction,
            handleGlobalSearch,
            setGlobalSearch,
            globalSearch,
            globalSearchRes,
            handleGetAllModeles,
            modeles,
            addInput,
            setArr,
            arr,
            handleChangeSimNumber,
            handleChangeAddNewSim,
            handleAddNewSimSubmit,
            handleChangeAddAccessoires,
            handleAddNewAccessoiresSubmit,
            getLogOfDevice,
            logDevices,
            showGlobalNotification,
            newTasksGlobal,
            resetNotificationBadge,
            showGlobalTaskNotification, // ← ajouter ici
            fetchUpdatedTasks,
            taskToConfirmedRef,
            handleCheckboxChange,
            selectedImages,
            setSelectedImages,
            deleteImageFn,
         }}
      >
         {children}
      </STcontext.Provider>
   );
};
export default STcontext;
